module.exports = {
      id: "user-icon-usage",
      viewBox: "0 0 18 20",
      url: __webpack_public_path__ + "svg-sprite-9bf32fda02e4f885c0073d291388af8d.svg#user-icon",
      toString: function () {
        return this.url;
      }
    }